import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-time-view',
    templateUrl: './time-view.component.html',
    styleUrls: ['./time-view.component.scss']
})
export class TimeViewComponent
{
    @Input() inputDate: string;
    @Input() enteredComments: string = '';

    private _editMode: boolean = false;
    private _enteredData: number = 0;
    private _initialized: boolean = false;

    @Input() set editMode(val: boolean)
    {
        this._editMode = val;
        if (val) { this._initialized = false; }
    }
    get editMode(): boolean { return this._editMode; }

    @Input() set enteredData(val: number)
    {
        if (!this._initialized)
        {
            this._enteredData = val ?? 0;
            this._initialized = true;
        }
    }
    get enteredData(): number { return this._enteredData; }

    @Output() dateTimeEntered = new EventEmitter<TimeViewEvent>();

    enteredTime($event: any)
    {
        if (this._editMode) { return; }
        const parsed = parseFloat($event);
        const clamped = isNaN(parsed) ? 0 : Math.min(Math.max(parsed, 0), 10);
        this._enteredData = clamped;
        this.emit();
    }

    enteredComment($event: string)
    {
        if (this._editMode) { return; }
        this.enteredComments = $event;
        this.emit();
    }

    private emit()
    {
        this.dateTimeEntered.emit({
            keyDate:  this.inputDate,
            value:    this._enteredData,
            comments: this.enteredComments
        });
    }
}

export interface TimeViewEvent
{
    keyDate: string;
    value: number;
    comments: string;
}
